import { Injectable, isDevMode } from '@angular/core';
import { AppError } from './app-error.model';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  error(error: AppError, context?: Record<string, unknown>): void {
    console.error('[AppError]', {
      ...this.buildPayload(error),
      context
    });
  }

  warn(message: string, context?: Record<string, unknown>): void {
    console.warn('[AppWarn]', { message, context });
  }

  info(message: string, context?: Record<string, unknown>): void {
    if (!isDevMode()) {
      return;
    }

    console.info('[AppInfo]', { message, context });
  }

  private buildPayload(error: AppError): Record<string, unknown> {
    return {
      code: error.code,
      category: error.category,
      source: error.source,
      severity: error.severity,
      technicalMessage: error.technicalMessage,
      httpStatus: error.httpStatus,
      endpoint: error.endpoint,
      details: error.details,
      timestamp: error.timestamp
    };
  }
}